<div class="pagination-container" [attr.data-testid]="testId">
  <!-- Desktop Layout -->
  <div class="desktop-layout">
    <ng-container *ngTemplateOutlet="navigationTemplate; context: { layout: '' }"></ng-container>
    <ng-container *ngTemplateOutlet="infoTemplate; context: { layout: '' }"></ng-container>
    <ng-container *ngTemplateOutlet="dropdownTemplate; context: { layout: '' }"></ng-container>
  </div>

  <!-- Mobile Layout -->
  <div class="mobile-layout">
    <div class="mobile-top-row">
      <ng-container
        *ngTemplateOutlet="navigationTemplate; context: { layout: 'mobile-' }"
      ></ng-container>
      <ng-container *ngTemplateOutlet="infoTemplate; context: { layout: 'mobile-' }"></ng-container>
    </div>
    <div class="mobile-bottom-row">
      <ng-container
        *ngTemplateOutlet="dropdownTemplate; context: { layout: 'mobile-' }"
      ></ng-container>
    </div>
  </div>
</div>

<!-- Reusable Templates -->
<ng-template #navigationTemplate let-layout="layout">
  <div class="page-navigation">
    <button
      class="nav-button"
      [attr.data-testid]="testId + '-' + layout + 'first-page-button'"
      (click)="onFirstPage()"
      [disabled]="paginationData.currentPage === 1"
      aria-label="First page"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 10.5L1 7L4.5 3.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 10.5L6 7L9.5 3.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button
      class="nav-button"
      [attr.data-testid]="testId + '-' + layout + 'previous-page-button'"
      (click)="onPreviousPage()"
      [disabled]="paginationData.currentPage === 1"
      aria-label="Previous page"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 10.5L5.25 7L8.75 3.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button
      class="nav-button"
      [attr.data-testid]="testId + '-' + layout + 'next-page-button'"
      (click)="onNextPage()"
      [disabled]="paginationData.currentPage === paginationData.totalPages"
      aria-label="Next page"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25 3.5L8.75 7L5.25 10.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <button
      class="nav-button"
      [attr.data-testid]="testId + '-' + layout + 'last-page-button'"
      (click)="onLastPage()"
      [disabled]="paginationData.currentPage === paginationData.totalPages"
      aria-label="Last page"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 3.5L8 7L4.5 10.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 3.5L13 7L9.5 10.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</ng-template>

<ng-template #infoTemplate let-layout="layout">
  <div
    class="pagination-info"
    [attr.data-testid]="testId + '-' + layout + 'info'"
    role="status"
    aria-live="polite"
  >
    {{ paginationInfo }}
  </div>
</ng-template>

<ng-template #dropdownTemplate let-layout="layout">
  <div class="items-per-page">
    <label class="items-per-page-label" for="items-per-page-select">Items per page</label>
    <div
      #dropdownTrigger
      class="custom-dropdown"
      [attr.data-testid]="testId + '-' + layout + 'items-per-page-trigger'"
      [class.open]="isDropdownOpen"
      (click)="toggleDropdown()"
      tabindex="0"
      role="combobox"
      aria-haspopup="listbox"
      aria-controls="items-per-page-listbox"
      [attr.aria-expanded]="isDropdownOpen"
    >
      <div class="dropdown-selected">
        <span class="selected-value">{{ paginationData.itemsPerPage }}</span>
        <svg
          class="dropdown-arrow"
          [class.rotated]="isDropdownOpen"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M3.5 5.25L7 8.75L10.5 5.25"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        id="items-per-page-listbox"
        class="dropdown-menu"
        [class.show]="isDropdownOpen"
        [ngStyle]="dropdownMenuFixedStyle"
        role="listbox"
        aria-label="Items per page options"
      >
        <div
          *ngFor="let option of itemsPerPageOptions; trackBy: trackByOption"
          class="dropdown-option"
          [class.selected]="option === paginationData.itemsPerPage"
          [attr.data-testid]="testId + '-' + layout + 'items-per-page-option-' + option"
          (click)="selectOption(option, $event)"
          role="option"
          [attr.aria-selected]="option === paginationData.itemsPerPage"
        >
          {{ option }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
